import React from "react";
import Input from "../../../UI/Input";
import {useDispatch, useSelector} from "react-redux";
import { setSendData, setTechnician } from "../../../Store/Slice/scheduleSlice";

export default function TicketInputs() {
  const dispatch = useDispatch();
  const sendData = useSelector((state) => state.rootReducer.scheduleSlice.sendData);
  const accountIndex = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  return (
      <>
          <div className="tech__row mt16">
              <div className="tech__field">
                  <div className="tech__field-input">
                      <Input
                          label="PO or Ref# (optional)"
                          placeholder="Enter PO or Ref#"
                          icon="/assets/icons/tag.svg"
                          value={sendData?.purchase_order || ''}
                          handleChange={(event) => {
                              dispatch(setTechnician({ purchase_order: event.target.value }));
                              dispatch(setSendData({ purchase_order: event.target.value }));
                          }}
                      />
                  </div>
              </div>
              <div className="tech__field">
                  <div className="tech__field-input">
                      <Input
                          label="Tracking number (optional)"
                          placeholder="Enter the link"
                          icon="/assets/icons/link.svg"
                          value={sendData?.tracking_number || ''}
                          handleChange={(event) => {
                              dispatch(setTechnician({ tracking_number: event.target.value }));
                              dispatch(setSendData({ tracking_number: event.target.value }));
                          }}
                      />
                  </div>
              </div>
          </div>
          <div className="tech__row mt16">
              {
                  accountIndex?.verification_key?.length ?
                  <div className="tech__field-v-key">
                      <Input
                          label="Verification Key"
                          placeholder="Enter Verification Key"
                          icon="/assets/icons/link.svg"
                          value={accountIndex?.verification_key}
                          readOnly={true}
                      />
                  </div> :
                  <div className="tech__field-v-key">
                      <Input
                          label="Verification Key"
                          placeholder="Enter Verification Key"
                          icon="/assets/icons/link.svg"
                          value={sendData?.verification_key || ''}
                          handleChange={(event) => {
                              dispatch(setTechnician({ verification_key: event.target.value }));
                              dispatch(setSendData({ verification_key: event.target.value }));
                          }}
                      />
                  </div>
              }
          </div>
      </>
  );
}
